/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PresignedUrlDetails {
    getFixupPrototypeFunction() { return PresignedUrlDetails.fixupPrototype; }

    static newInstance(model: Partial<PresignedUrlDetails>): PresignedUrlDetails {
        let obj = Object.assign(new PresignedUrlDetails(), model);
        PresignedUrlDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PresignedUrlDetails>): PresignedUrlDetails {
        if (!model) return null;
        return PresignedUrlDetails.newInstance(<PresignedUrlDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PresignedUrlDetails) {
        if (!obj) return;

        models.PresignedUrlDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PresignedUrlDetails): boolean {
        Object.setPrototypeOf(obj, PresignedUrlDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.part_number === undefined) {
            this.part_number = 0;
        }
    }

    /**
     * Part number of the file part
     */
    part_number: number;

    /**
     * Presigned URL for uploading the file part
     */
    url: string;

}
